<div [class]="styleClass">
  <img [src]="icon" alt="message-icon" />
  <span class="header">{{field.name}}</span>
  <span class="description">{{field.description}}</span>
</div>